const sprites = {
  url: 'https://www.officeworks.com.au/web-ui-kit/current/images/sprites.svg'
};

export default sprites;



// WEBPACK FOOTER //
// ./src/config/sprites.js